export default __webpack_public_path__ + "static/media/comming.58bf2e4d.jpg";